<!-- COMMENT OUT large loaders -->
<!-- <div *ngIf="showFormLoader" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">Consolidation Ledgers</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">

@if (!showFormLoader) {
<div>
    <div style="width: 90%; margin-bottom: 15px">
        <table style="width: 100%;">
          <tbody>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td class="LayerLine1" nowrap>Parent ME Code:</td>
              <td id="CLIS_CRUD_1" class="LayerData1" nowrap>{{rowData.PARENT_ME_CODE}}</td>
              <td class="LayerLine1" nowrap>LEID:</td>
              <td id="CLIS_CRUD_1" class="LayerData1" nowrap>{{rowData.LEID}}</td>
              <td class="LayerLine1" nowrap>Tax Code:</td>
              <td id="CLIS_CRUD_3" class="LayerData1" nowrap>{{rowData.CDR_NO}}</td>
              <td class="LayerLine1" nowrap>Ledger:</td>
              <td id="CLIS_CRUD_3" class="LayerData1" nowrap>{{rowData.LEDGER}}</td>
            </tr>
          </tbody>
        </table>
      </div>
</div>
}

  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    @if (activeTab === 1) {
<div class="tab-pane active">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>

          <!-- Net Income Display -->
          <div>
            <table style="margin-left: 20px; margin-top: 15px;">
              <tbody>
                <tr>
                  <td class="LayerLine1" nowrap>Net Income :</td>
                  <td id="CLIS_CRUD_1" [ngClass]="{'color-red': rowData.NET_INCM < 0}">
                    {{formatNetIncome(rowData.NET_INCM)}}
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Income Statement Table with Scroll Container -->
          <div class="table-scroll-container">
            <table class="table table-bordered form-inline custom-table" style="margin-bottom: 0px;">
              <tbody>
                <!-- TABLE HEADER -->
                <tr>
                  @for (val of tableHeader; track $index; let i = $index) {
<th style="text-align: center;" class="sticky-col" [id]="'CLIS_HEADER_CRUD_' + i">
                    {{val}}
                  </th>
}
                  <th style="text-align: center;" class="sticky-col" id="CLIS_HEADER_CRUD_Cate">Category</th>
                </tr>
                
                <!-- TABLE ROWS -->
                @for (row of incomeStmtList; track itemTracker(row); let i = $index) {
<tr 
                    class="table1" 
                    [style.display]="row.IS_DISPLAY ? 'table-row' : 'none'">
                  <td [id]="'CLIS_TABLE_' + (i + 1)">{{row.BSLA}}</td>
                  <td [id]="'CLIS_TABLE_' + (i + 1)">{{row.ACCOUNT}}</td>
                  <td [id]="'CLIS_TABLE_' + (i + 1)" style="width: 650px">{{row.ACCOUNT_DESC}}</td>
                  <td [id]="'CLIS_TABLE_' + (i + 1)" style="text-align: right">
                    <input [id]="'CRDNO_' + (i + 1)"
                           [ngClass]="{'color-red': row.AMOUNT < 0}"
                           class="form-control input-md numText" 
                           style="text-align: right !important"
                           type="text"
                           [value]="formatNumber(row.AMOUNT)"
                           [disabled]="row.OCCURRENCE == 1"
                           placeholder="" 
                           aria-describedby="basic-addon2"
                           (input)="onAmountInput($event, row)"
                           allow-negative="true" 
                           allow-decimal="false" />
                  </td>
                  <td [id]="'CLIS_TABLE_Dropdown_' + (i + 1)" style="text-align: center">
                    <select style="height: 30px;"
                            (ngModelChange)="valueCategoryChanged(row)"
                            [(ngModel)]="row.CATEGORY">
                      <option value="">-- please select One --</option>
                      @for (item of catDropdown; track $index) {
<option [value]="item.CODE_NAME">
                        {{item.CODE_DESC}}
                      </option>
}
                    </select>
                    
                    @if (row.OCCURRENCE == 1) {
<span (click)="addRow(row)" style="cursor: pointer; padding: 5px">
                      <i style="color: green; font-size: 22px;" class="fa fa-plus-circle"></i>
                    </span>
}
                    
                    @if (row.OCCURRENCE != 1) {
<span (click)="deleteRow(row)" style="cursor: pointer; padding: 5px">
                      <i style="color: red; font-size: 22px;" class="fa fa-minus-circle"></i>
                    </span>
}
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>

          <!-- No Records Message -->
          @if (noRecords) {
<div 
               style="width: 100%; background-color: #d7d7d7; height: 80px; padding: 20px;">
            <table style="width: 70%;">
              <tbody>
                <tr class="no-records">
                  <td style="padding-right: 20%;" nowrap>
                    <h4><b> No Records Available </b></h4>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
}

          <!-- Variance Display -->
          <div style="width: 90%; padding-top: 25px;">
            <table style="width: 70%;">
              <tbody>
                <tr>
                  <td class="LayerLine1" nowrap>
                    <h4><b> Variance : </b></h4>
                  </td>
                  <td id="CLIS_CRUD_1">
                    <h4>{{variance}}</h4>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
}
      </div>
    </div>
}

    <!-- Balance Sheet Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active" style="padding-top: 15px">
      <div class="form-horizontal">
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}
        
        @if (!showFormLoader) {
<div>
          <div class="table-scroll-container">
            <table class="table table-bordered form-inline custom-table">
              <tbody>
                <!-- TABLE HEADER -->
                <tr>
                  @for (val of tableHeader; track $index; let i = $index) {
<th style="text-align: center;" class="sticky-col" [id]="'CLBS_HEADER_CRUD_' + i">
                    {{val}}
                  </th>
}
                </tr>
                
                <!-- TABLE ROWS -->
                @for (rowBS of balanceSheetList; track itemTracker(rowBS); let i = $index) {
<tr class="table1">
                  <td [id]="'CLBS_TABLE_' + (i + 1)">{{rowBS.ME_CODE}}</td>
                  <td [id]="'CLBS_TABLE_' + (i + 1)">{{rowBS.ACCOUNT}}</td>
                  <td [id]="'CLBS_TABLE_' + (i + 1)">{{rowBS.ACCOUNT_DESC}}</td>
                  <td [id]="'CLBS_TABLE_' + (i + 1)" style="text-align: right;" [ngClass]="{'color-red': rowBS.AMT < 0}">
                    {{formatNetIncome(rowBS.AMT)}}
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button  
          class="save-button"  
          type="button"  
          [disabled]="isSaveClicked"  
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button  
          class="reset-button"  
          type="button"  
          (click)="reset()">Reset</button>
}
  <button class="cancel-button"  
          type="button"  
          (click)="cancel()">Cancel</button>
</div>
